import { useAppAuth } from "@/auth/use-app-auth";
import { useQuery } from "@tanstack/react-query";
import { Axios } from "@/lib/axios";

export const useAuthProfile = (enabled = true) => {
  const { isAuthenticated, getAccessTokenSilently } = useAppAuth();

  return useQuery({
    queryKey: ["auth", "profile"],
    queryFn: async () => {
      const token = await getAccessTokenSilently();
      const response = await Axios.get("/api/auth/profile", {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    },
    enabled: isAuthenticated && enabled,
    staleTime: 60 * 1000,
  });
};
